import { Pipe, PipeTransform } from '@angular/core';

import moment from 'moment';

import { SpaLoadPeriodDTO } from '@api';

@Pipe({
  name: 'calculateBackgroundColor',
  standalone: false,
})
export class CalculateBackgroundColorPipe implements PipeTransform {
  transform(
    timeLoad: SpaLoadPeriodDTO | undefined,
    pastColor: string,
    manyAvailableTickets: string,
    someAvailableTickets: string,
    lessAvailableTickets: string,
  ): string {
    let color: string;
    if (moment().isBefore(moment(timeLoad?.period?.to)) || timeLoad?.period?.to == null) {
      const reserved = timeLoad?.load?.reserved ?? 0;
      const present = timeLoad?.load?.present ?? 0;
      const available = timeLoad?.load?.available;
      const percentages = available ? ((reserved + present) / available) * 100 : 0;
      if (percentages >= 90) {
        color = lessAvailableTickets;
      } else if (percentages >= 50 && percentages < 90) {
        color = someAvailableTickets;
      } else {
        color = manyAvailableTickets;
      }
    } else {
      color = pastColor;
    }
    return color;
  }
}

@Pipe({
  name: 'calculateBackgroundColor2',
  standalone: false,
})
export class CalculateBackgroundColorPipe2 implements PipeTransform {
  transform(timeLoad: SpaLoadPeriodDTO | undefined, segment: string): string {
    let className: string;
    if (moment().isBefore(moment(timeLoad?.period?.to)) || timeLoad?.period?.to == null) {
      const reserved = timeLoad?.load?.reserved ?? 0;
      const present = timeLoad?.load?.present ?? 0;
      const available = timeLoad?.load?.available;
      const percentages = available ? ((reserved + present) / available) * 100 : 0;
      if (percentages >= 90) {
        className = 'less-available' + '-' + segment + '-' + 'segment';
      } else if (percentages >= 50 && percentages < 90) {
        className = 'some-available' + '-' + segment + '-' + 'segment';
      } else {
        className = 'many-available' + '-' + segment + '-' + 'segment';
      }
    } else {
      className = 'past' + '-' + segment + '-' + 'segment';
    }
    return className;
  }
}
